import { render, staticRenderFns } from "./DefaultResultsScreen.vue?vue&type=template&id=0d778892&scoped=true&"
import script from "./DefaultResultsScreen.vue?vue&type=script&lang=js&"
export * from "./DefaultResultsScreen.vue?vue&type=script&lang=js&"
import style0 from "./DefaultResultsScreen.vue?vue&type=style&index=0&id=0d778892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d778892",
  null
  
)

export default component.exports